"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.screen_percentage = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var screen_percentage = function screen_percentage(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'screen-percentage-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M3.5 4.5V15.5H16.5V4.5H3.5ZM3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V4C18 3.44772 17.5523 3 17 3H3Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M7.39844 10.5781C8.33203 10.5781 8.90625 9.94531 8.90625 8.92578V8.92188C8.90625 7.90234 8.33203 7.27344 7.39844 7.27344C6.46484 7.27344 5.88672 7.90234 5.88672 8.92188V8.92578C5.88672 9.94531 6.46484 10.5781 7.39844 10.5781ZM8.70703 13L12.4609 7.36328H11.2891L7.53516 13H8.70703ZM7.39844 9.79297C7.10547 9.79297 6.94531 9.49609 6.94531 8.92578V8.92188C6.94531 8.35156 7.10547 8.05859 7.39844 8.05859C7.69531 8.05859 7.85156 8.35156 7.85156 8.92188V8.92578C7.85156 9.49609 7.69531 9.79297 7.39844 9.79297ZM12.6016 13.0898C13.5352 13.0898 14.1094 12.457 14.1094 11.4375V11.4336C14.1094 10.4141 13.5352 9.78516 12.6016 9.78516C11.668 9.78516 11.0898 10.4141 11.0898 11.4336V11.4375C11.0898 12.457 11.668 13.0898 12.6016 13.0898ZM12.6016 12.3047C12.3086 12.3047 12.1484 12.0078 12.1484 11.4375V11.4336C12.1484 10.8633 12.3086 10.5703 12.6016 10.5703C12.8984 10.5703 13.0547 10.8633 13.0547 11.4336V11.4375C13.0547 12.0078 12.8984 12.3047 12.6016 12.3047Z',
    fill: '#4B5563'
  }));
};

exports.screen_percentage = screen_percentage;